import { Push as PushComponent } from './Push.component';
import { connector } from './Push.connector';

export const Push = connector(PushComponent);
